import * as angular from "angular";

export class OrderPlanningConfigurationRequestsService {

  constructor(private $orderPlanningConfiguration, private OrdersPlanningConfigurationAPI) {
  }


  // ******************************
  // External methods
  // ******************************

  create(configuration: any) {
    const api = this.OrdersPlanningConfigurationAPI.actions.create;
    return this.$$call(api, {}, configuration, {});
  }

  update(configuration: any) {
    const api = this.OrdersPlanningConfigurationAPI.actions.update;
    return this.$$call(api, {}, configuration, {id: configuration.id});
  }

  delete(configurationId: string) {
    const api = this.OrdersPlanningConfigurationAPI.actions.delete;
    return this.$$call(api, {}, {}, {id: configurationId});
  }

  // ******************************
  // Internal methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    return this.$orderPlanningConfiguration().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.order-planning-configuration')
  .service('orderPlanningConfigurationRequestsService', OrderPlanningConfigurationRequestsService);
